import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import interactionPlugin from "@fullcalendar/interaction";
import { Popover } from "bootstrap";
import { CalWrapper } from "./SPCalendar.style";

let popoverInstance = null;

// const API_KEY = "AIzaSyCcNHBgzJ5maW7Kf-CMQTLdkl9s8ZV_M3g";
// const calendarId = "starsacramento.org_qca4hlbv93lr62ka7n0ne1l6uc@group.calendar.google.com";

const SPCalendar = () => {
  const handleMouseEnter = (info) => {
    if (info.event.extendedProps) {
      console.info(info.event.extendedProps);
      popoverInstance = new Popover(info.el, {
        // attachements: info.event.extendedProps.attachments.title,
        title: info.event.extendedProps.description,
        content: info.event.extendedProps.location,
        // colorId: info.event.extendedProps.background,
        html: true,
        placement: "auto",
        trigger: "hover",
        container: "body",
      });

      popoverInstance.show();
    }
  };

  const handleMouseLeave = () => {
    if (popoverInstance) {
      popoverInstance.dispose();
      popoverInstance = null;
    }
  };

  return (
    <CalWrapper>
      <FullCalendar
        plugins={[dayGridPlugin, googleCalendarPlugin, interactionPlugin]}
        googleCalendarApiKey="AIzaSyCL2TjqSpRRfU-gl1asTltqEbl6gTkhdaI"
        initialView="dayGridMonth"
        initialDate="2024-06-01"
        // eventColor="orange"
        // eventOrder="groupId"
        // eventOrderStrict={true}
        eventDisplay="block"
        displayEventTime={true}
        // height= "300px"
        // selectable={true}
        eventMouseEnter={handleMouseEnter}
        eventMouseLeave={handleMouseLeave}
        eventSources={[
          {
            googleCalendarId:
              "c_d64e81ad81543db22bd3c86f087e5f06077c3141674bf042bc8fd9f1cdcc4fcc@group.calendar.google.com",
            color: "#85ff8d",
            backgroundColor: "#85ff8d",
            textColor: "black",
          },
        ]}
        eventClick={[
          function (info) {
            info.jsEvent.preventDefault(); // don't let the browser navigate

            // if (info.event.url) {
            //   window.open(info.event.url);
            // }
          },
        ]}
      />
    </CalWrapper>
  );
};

export default SPCalendar;
